import React from 'react';

import {
  MAXIMUM_COMPANION_QUANTITY,
  MINIMUM_COMPANION_QUANTITY,
} from 'components/shop/MobilePlans/constants/plans.constants';
import {
  MobilePlansDetails,
  RelatedOfferDetails,
} from 'components/shop/MobilePlans/typings/plans';
import BaseSelectQuantityStep from '../BaseSelectQuantityStep';
import QuantitySelectorWithActions from '../BaseSelectQuantityStep/components/QuantitySelectorWithActions';
import SelectQuantityStepHeading from '../BaseSelectQuantityStep/components/SelectQuantityStepHeading';

interface SelectCompanionQuantityStepProps {
  companionPlan: RelatedOfferDetails;
  planCardsProducts: MobilePlansDetails;
  isAddingBundles: boolean;
  isLastQuantityStep?: boolean;
  defaultQuantity?: number;
  onNext(): void;
  onSkip(): void;
}
const COMPANION_PLAN_REGION_ID = 'addCompanionPlansActionLayer';
const COMPANION_PLAN_DETAILS_CONTENT_KEY = 'companion-plan-details';
const COMPANION_PLAN_INFORMATION_ICON_TITLE =
  'Companion plan details information icon';
const COMPANION_PLAN_HEADING_TITLE = 'Companion plan details';
const COMPANION_PLAN_HEADING_ICON_ARIA_LABEL =
  'View companion plan details information';
const COMPANION_PLAN_TRACKING_EVENT_NAME =
  'Companion Plan Details Action Layer';
const COMPANION_PLAN_QUANTITY_SELECTOR_LABEL =
  'Select number of companion plans';
const COMPANION_PLAN_QUANTITY_SELECTOR_SUFFIX = 'companion';

const SelectCompanionQuantityStep = ({
  companionPlan,
  planCardsProducts,
  isAddingBundles,
  defaultQuantity = MINIMUM_COMPANION_QUANTITY,
  isLastQuantityStep = true,
  onNext,
  onSkip,
}: SelectCompanionQuantityStepProps) => {
  return (
    <BaseSelectQuantityStep
      plan={companionPlan}
      regionId={COMPANION_PLAN_REGION_ID}
      heading={
        <SelectQuantityStepHeading
          iconTitle={COMPANION_PLAN_INFORMATION_ICON_TITLE}
          infoDetailsContentKey={COMPANION_PLAN_DETAILS_CONTENT_KEY}
          title={COMPANION_PLAN_HEADING_TITLE}
          iconAriaLabel={COMPANION_PLAN_HEADING_ICON_ARIA_LABEL}
          planCardsProducts={planCardsProducts}
          trackingEventName={COMPANION_PLAN_TRACKING_EVENT_NAME}
        />
      }
      quantitySelector={
        <QuantitySelectorWithActions
          label={COMPANION_PLAN_QUANTITY_SELECTOR_LABEL}
          suffix={COMPANION_PLAN_QUANTITY_SELECTOR_SUFFIX}
          minQuantity={MINIMUM_COMPANION_QUANTITY}
          maxQuantity={MAXIMUM_COMPANION_QUANTITY}
          isAddingBundles={isAddingBundles}
          isLoading={false}
          isLastQuantityStep={isLastQuantityStep}
          defaultQuantity={defaultQuantity}
          plan={companionPlan}
          onSkip={onSkip}
          onNext={onNext}
        />
      }
    />
  );
};

export default SelectCompanionQuantityStep;
